var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "131.25 131.25 112.5 112.5",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "47a8884a8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 131.25 131.25 L 243.75 131.25 L 243.75 243.75 L 131.25 243.75 Z M 131.25 131.25",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "032277a384"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 131.25 C 156.433594 131.25 131.25 156.433594 131.25 187.5 C 131.25 218.566406 156.433594 243.75 187.5 243.75 C 218.566406 243.75 243.75 218.566406 243.75 187.5 C 243.75 156.433594 218.566406 131.25 187.5 131.25 Z M 187.5 131.25",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47a8884a8d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#032277a384)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9961",
    d: "M 131.25 131.25 L 243.75 131.25 L 243.75 243.75 L 131.25 243.75 Z M 131.25 131.25",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.68bdf87c47b29bce6d4ac9581b38a85b.svg";
export { ForwardRef as ReactComponent };